export class Socio {

   public id:number;
   public codigoConsorcio:string;
   public codigoSocio:string;
   public tipo:string;
   public nombre:string;
   public direccion:string;
   public telefono:string;
   public email:string;
   public web:string;
   public referenciaERP:string;
   public contacto:string;
   
}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/model/socio.ts